import { useState, useEffect, useMemo } from 'react';
import { Button } from 'semantic-ui-react';
import Loading from '../../../components/Loading';
import CenterCell from '../../../components/table/CenterCell';
import BasicPaginatedTable from '../../../components/table/BasicPaginatedTable';
import { getAPI } from '../../../libs/fetchAPI';

function Organizations() {
	const [ loading, setLoading ]                         = useState(true);
	const [ users, setUsers ]                             = useState([]);
	const [ , setCurrentOrganization ] = useState();
	const [ , setShowEditModal ]             = useState(false);

	useEffect(() => {
		setLoading(true);
		getAPI(`/organizations`)
			.then(({ data }) => {
				setUsers(data);
				setLoading(false);
			});
	}, []);

	function handleEditOrganization(user_id) {
		setShowEditModal(true);
		setCurrentOrganization(user_id);
	}

	const columns = useMemo(() => [
		{
			Header   : `Title`,
			accessor : `title`,
		},
		{
			Header         : ``,
			accessor       : `id`,
			collapse       : true,
			disableFilters : true,
			Cell           : ({ cell }) => <CenterCell><Button primary onClick={() => handleEditOrganization(cell.value)}>Edit</Button></CenterCell>
		}
	], []);

	if(loading) {
		return <Loading />
	}

	return (
		<>
			<BasicPaginatedTable
				columns={columns}
				data={users}
				default_page_size="15"
			/>
		</>
	);
}

export default Organizations;
